import { Editor } from "@monaco-editor/react";
import { defineCustomTheme } from "./monacoTheme";
import { Spinner } from "reactstrap";

const MonacoEditor = ({ initialValue = "", handleEditorChange, language = "html", loading, isEditable }) => {

  const handleMount = (editor, monaco) => {
    defineCustomTheme(monaco)

    monaco.editor.setTheme('customTheme')
    handleEditorChange(initialValue)
  }

  if (loading) {
    return <Spinner color="primary" />;
  }

  return (
    <Editor
      height="500px"
      defaultLanguage={language}
      defaultValue={initialValue}
      theme="customTheme"
      onMount={handleMount}
      onChange={(value) => {
        handleEditorChange(value)
      }}
      options={{
        minimap: {
          enabled: false
        },
        lineNumbers: "on",
        wordWrap: "off",
        tabSize: 2,
        insertSpaces: true,
        autoClosingBrackets: "always",
        autoClosingQuotes: "always",
        autoIndent: "full",
        formatOnPaste: true,
        formatOnType: true,
        suggestOnTriggerCharacters: true,
        matchBrackets: "always",
        occurrencesHighlight: "singleFile",
        automaticLayout: true,
        scrollBeyondLastLine: true,
        padding: {
          top: 20,
          bottom: 20
        },
        readOnly: isEditable,
      }}
    />
  );
};

export default MonacoEditor;
